<template>
    <div>
        <partial-navbar></partial-navbar>
        <div role="main" class="main">
            <section v-if="showMenu && pageTitle !== '' " class="page-header page-header-modern page-header-background page-header-background-sm overlay overlay-color-dark overlay-show overlay-op-5" :style="`background-image: url('${imgHeader}');background-attachment:static;background-position: center;`">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12 align-self-center p-static order-1 text-center">
                            <h1>{{ pageTitle }}</h1>
                            <span class="sub-title" v-if="1==2 && subtitle != ''">{{ subtitle }}</span>
                        </div>
                        <div class="col-md-12 align-self-center order-2 text-center" v-if="breadcrumbs.length > 0">
                            <ul class="breadcrumb breadcrumb-light d-block text-center">
                                <li v-for="breadcrumb in breadcrumbs" v-bind:class="(breadcrumb.active)?'active':''">
                                    <router-link v-if="typeof breadcrumb.to !== 'undefined'" :to="breadcrumb.to">{{ breadcrumb.title }}</router-link>
                                    <span class="text-white" v-else>{{ breadcrumb.title }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </section>
            <router-view></router-view>
        </div>
        <component :is="modalComponent" :modal=modal></component>
        <partial-footer></partial-footer>
    </div>
</template>

<script>
import {frontendRoutes} from "../../routes";
import moment from "moment";
import PartialNavbar from './partials/Navbar.vue';

export default {
    name: "App.vue",
     components: {
     'partial-navbar': PartialNavbar
    },
    data(){
      return {
          showMenu: false,
          shoppingCartKey: false,
          shoppingCart: false,
          user: false,
          pageTitle:'',
          subtitle:'',
          breadcrumbs:[],
          imgHeader: '/images/headers/1.jpg',
          isLoggedIn: false,
          onlyBooking: false,
          modalComponent: null,
          modal:{},
          app_js_date:''
      }
    },
    created() {
        this.app_js_date = moment();
    },
    async updated() {
        if(moment().diff(this.app_js_date,'hours')>24){
            location.reload(true);
        }
        if (this.$route.name === 'home') {
            this.showMenu = false
        } else {
            this.showMenu = true
        }
        if (this.$cookies.isKey('jwt')) {
            this.axios.defaults.headers.common["Authorization"] = `Bearer ${this.$cookies.get('jwt')}`;
        } else if (typeof this.axios.defaults.headers.common["Authorization"] !== 'undefined') {
            delete this.axios.defaults.headers.common["Authorization"];
        }
        if (this.$cookies.isKey("shoppingCart")) {
            this.shoppingCartKey = this.$cookies.get("shoppingCart");
            this.getShoppingCart();
        } else {
            this.shoppingCartKey = false;
            this.shoppingCart = false;
        }
        this.isLoggedIn = (sessionStorage.getItem('jwt'));
    },
    watch:{
        $route (to, from){
            this.getModals(to.name);
        }
    },
    async beforeMount() {
        if(!this.$cookies.isKey("i18n")){
            await this.updateLocale('es')
        }
        this.$i18n.locale = (this.$cookies.isKey("i18n"))?this.$cookies.get("i18n"):this.$i18n.fallbackLocale;
        await this.getUser();
    },
    async mounted() {
        if (this.$cookies.isKey('jwt')) {
            this.axios.defaults.headers.common["Authorization"] = `Bearer ${this.$cookies.get('jwt')}`;
        } else {
            delete this.axios.defaults.headers.common["Authorization"];
        }
        this.isLoggedIn = (sessionStorage.getItem('jwt'));
    },
    methods:{
        async getShoppingCart(){
            let self = this;
            await this.axios.get('/api/shopping-carts/'+this.shoppingCartKey)
                .then(response => {
                    if(parseInt(response.data.status) === 1){
                        self.shoppingCart = response.data;
                        self.isOnlyBooking();
                    } else {
                        self.$cookies.remove('shoppingCart');
                        self.shoppingCart = false;
                        self.shoppingCartKey = false
                    }
                })
                .catch(function (error) {
                    self.$cookies.remove('shoppingCart');
                    self.shoppingCart = false;
                    self.shoppingCartKey = false
                });
        },
        isOnlyBooking(){
            this.onlyBooking = true;
            if(typeof this.shoppingCart === 'object' && typeof this.shoppingCart.items.find !== 'undefined') {
                this.onlyBooking = (typeof this.shoppingCart.items.find(o => o.salable_type === 'artwork').id === 'undefined');
            }
        },
        async getUser(){
            await this.axios.get(`/api/profile`)
                .then(response=>{
                    this.user = response.data
                })
                .catch(error=>{
                    this.$cookies.remove('jwt')
                    this.user = null
                })
        },

        async logout() {
            await this.axios.get('/sanctum/csrf-cookie').then(response => {
                this.axios.post('/api/logout')
                    .then(response => {
                        sessionStorage.clear();
                        this.isLoggedIn = false;
                        this.$cookies.remove('jwt')
                        this.$router.go();
                        this.user = null
                    })
                    .catch(function (error) {
                        console.error(error);
                    });
            })
        },
        async setLocale(event){
            let self = this;
            let locale = event.target.value;
            await this.updateLocale(locale)
        },
        async updateLocale(locale){
            let self = this;
            await this.axios.get(`/api/change-locale/${locale}`)
                .then(response => {
                    self.$cookies.set("i18n",locale,'100d');
                    self.$i18n.locale = locale;
                    let curName = self.$route.name;
                    let route = frontendRoutes[locale].find(x => x.name === curName).path;
                    let params = Object.keys(self.$route.params);
                    params.forEach((key, index) => {
                        let value = self.$route.params[key];
                        route = route.replace(`:${key}`,value)
                    });
                    window.location = route;
                });
        },
        async getModals(page){
            await this.axios.get(`/api/modals?page=${page}&all=1`)
                .then(response=>{
                    if(response.data.length > 0){
                        let item = Math.floor(Math.random()*response.data.length)
                        this.modal = response.data[item];
                        this.modalComponent = 'modal-frontend';
                    }
                    else {
                        this.modalComponent = null;
                    }
                })
        }
    }
}
</script>
<style scoped>

</style>
